import {
  isFullAccessUser,
  isMemberSafePath,
  isMemberUser,
  type RoleAwareUser,
} from '../platform/auth/userRoles';

export type LayoutShellMode = 'admin' | 'coach' | 'member';

export const resolveLayoutShellMode = (pathname: string, user?: RoleAwareUser): LayoutShellMode => {
  if (pathname.startsWith('/admin')) {
    return 'admin';
  }

  if (isMemberSafePath(pathname) && isMemberUser(user)) {
    return 'member';
  }

  if (isFullAccessUser(user)) {
    return 'coach';
  }

  return 'coach';
};

export const defaultShellHomeRoute = (shellMode: LayoutShellMode): string => {
  if (shellMode === 'admin') {
    return '/admin';
  }

  if (shellMode === 'member') {
    return '/artifacts';
  }

  return '/members';
};
